module.exports = __webpack_public_path__ + "d2.no2.aba05b09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d2.no2.jpg
// module id = N3Uq
// module chunks = 0